import type { AppSelector } from "src/types";
import type { ModalId, ModalsState } from "./types";

const getModel: AppSelector<ModalsState> = (state) => state.modalsModule;

/**
 * Gets entity from state by its id, or undefined if it does not exists.
 */
export const isModalOpen: AppSelector<boolean | undefined, ModalId> = (state, id) => getModel(state).modals[id];
